import { ClientOnly } from '~/decorators'
import { containerScoped } from '~/decorators/dependency-container'

@ClientOnly
@containerScoped()
export class FacebookPixelService {
  initialize() {
    const ownFbPixelId = this.getOwnFbPixelIdFromEnvVar()
    if (!ownFbPixelId) {
      return
    }

    ;(function(f, b, e, v, n, t, s) {
      if (f.fbq) return
      // @ts-ignore
      n = f.fbq = function() {
        // @ts-ignore
        n.callMethod
          ? // @ts-ignore
            n.callMethod.apply(n, arguments)
          : // @ts-ignore
            n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      // @ts-ignore
      n.push = n
      // @ts-ignore
      n.loaded = !0
      // @ts-ignore
      n.version = '2.0'
      // @ts-ignore
      n.queue = []
      // @ts-ignore
      t = b.createElement(e)
      // @ts-ignore
      t.async = !0
      // @ts-ignore
      t.src = v
      // @ts-ignore
      s = b.getElementsByTagName(e)[0]
      // @ts-ignore
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )

    const fbq = this.getFbPixel()
    fbq('set', 'autoConfig', 'false', ownFbPixelId)
    fbq('init', ownFbPixelId)
  }

  sendPageView() {
    const fbq = this.getFbPixel()
    fbq('track', 'PageView')
  }

  /**
   * Returns facebook pixel client.
   * @private
   */
  private getFbPixel(): Function {
    // TODO: Add types when they mature: `@types/facebook-pixel`
    return window.fbq
  }

  private getOwnFbPixelIdFromEnvVar(): string | undefined {
    return process.env.FACEBOOK_PIXEL_ID
  }
}
